import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import MarketplaceTeam from "marketplace/teams/team";
import Marketplace from "work/work-agreements/teams/vendor-team/_views/marketplace/vendor-marketplace";

const PageContainer = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  alignSelf: "stretch",
  minHeight: 0,
  minWidth: 0,
  width: "100%",
}));
const TabContent = styled("div")(() => ({
  display: "flex",
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  width: "100%",
}));

type VendorTeamSelectionProps = {
  searchParams?: URLSearchParams;
  filterPresentation?: "dialog" | "contained";
  onFilterViewOpenChange?: (isOpen: boolean) => void;
  onNewSelection: (team: MarketplaceTeam) => void;
  closeDialog: () => void;
};

export default function VendorTeamSelection(props: Readonly<VendorTeamSelectionProps>) {
  const { searchParams, filterPresentation, onFilterViewOpenChange, onNewSelection } = props;

  return (
    <PageContainer>
      <TabContent>
        <Marketplace
          selectingTeam={true}
          searchParams={searchParams}
          filterPresentation={filterPresentation}
          onContainedFilterOpenChange={onFilterViewOpenChange}
          onTeamSelected={onNewSelection}
        />
      </TabContent>
    </PageContainer>
  );
}
